import { useContext } from 'react';
import { SidebarContext, SidebarContextType } from './sidebar-context-def';

export const useSidebarData = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarData must be used within a SidebarDataProvider');
  }
  return context;
};
